import { api } from '@/fsd/shared/api';

interface IOnboardingDataStatus {
  message: string;
  data: {
    bank_upload_done: boolean;
    pnl_report_done: boolean;
    marketplace_upload_done: boolean;
    marketplaces: {
      marketplace: string;
      done: boolean;
    }[];
  };
}

export const getAccountCabinetOnboardingDataStatus = async () => {
  return await api.get<IOnboardingDataStatus>(
    `/api/v1/account/cabinet/onboarding/data-status/`
  );
};
